import { 
  Suspense
} from "react";
import { LinearProgress } from "@mui/material";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { routes } from "../src/routes";

export default function App() {
  return (
    <Suspense fallback={<LinearProgress />}>
      <BrowserRouter>
        <Routes>
          {routes.map(({ path, element: Element }, index) => (
            <Route key={index} path={path} element={Element} />
          ))}
        </Routes>
      </BrowserRouter>
    </Suspense>
  );
}
